<div class="flex items-center justify-between">
  <div class="branding"><app-branding></app-branding></div>

  @if(showToggle) {
  <button type="button" (click)="toggleMobileNav.emit()" class="overlay-nav-close flex justify-center items-center"
    [attr.aria-label]="'layout.closeMenu' | translate">
    <i-tabler name="x" class="flex"></i-tabler>
  </button>
  }
</div>
